const emailTemplates = (state) => state.emailTemplates;
const hasEmailTemplates = (state) => state.emailTemplates.length > 0;

const hasEmailTemplateById = (state) => (id) => typeof state.emailTemplatesCache
  .find((emailTemplate) => emailTemplate.id === id) !== "undefined";

const getEmailTemplateById = (state) => (id) => state.emailTemplatesCache
  .find((emailTemplate) => emailTemplate.id === id);

export default {
  emailTemplates,
  hasEmailTemplates,
  hasEmailTemplateById,
  getEmailTemplateById,
};
